import React from "react";
import Select from "react-select";
const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: "1px solid #EAEBEF",
        padding: 10,
        fontSize: 12,
        color: "#58585B",
    }),
    control: () => ({
        width: "100%",
    }),
};
export default class SelectDropDown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCLose: true,
        };
        this.clear = React.createRef();
    }

    getDefaultValue() {

        let defautValue = this.props.options.find(
            (option) => option.value === this.props.value,
        );

        if (this.props?.groupedOptions) {
            this.props.options?.forEach((item) => {
                item?.options?.forEach((option) => {
                    if (option.value == this.props.value) {
                        defautValue = option;
                    }
                });
            });
        }
        return defautValue;
    }

    clearValue = () => {
        this.clear.current.select.clearValue();
        if (this.props.templateReset) {
            this.props.templateReset();
        }
    };

    render() {
        return (
            <div className="positionRelative">
                <Select
                    className={`${this.state.menuCLose ? "custom-slect customselectdropdown11" : "active-slect"} ${this?.props?.className ?? ""}`}
                    styles={customStyles}
                    name={this.props.name}
                    placeholder={this.props.placeholder}
                    value={this.getDefaultValue()}
                    onChange={(selectedOption) => {
                        this.props.handleChange(selectedOption);
                    }}
                    isInvalid={this.props.touched && !this.props.errors}
                    isValid={this.props.is_submitted && !this.props.errors}
                    options={this.props.options}
                    onMenuClose={(e) => this.setState({ menuCLose: true })}
                    onMenuOpen={(e) => this.setState({ menuCLose: false })}
                    isSearchable={
                        this.props.isSearchable
                            ? this.props.isSearchable
                            : false
                    }
                    ref={this.clear}
                    isMulti={this.props.isMulti ? this.props.isMulti : false}
                />
                {this.props.clearValue === true && (
                    <button
                        className="clearBtn"
                        type="button"
                        onClick={this.clearValue}
                    >
                        x
                    </button>
                )}
            </div>
        );
    }
}
